import {ApolloClient, ApolloLink, createHttpLink, InMemoryCache} from '@apollo/client/core';
import {GRAPHQL_URI, APOLLO_DEV_TOOLS} from './constants';

const httpLink = createHttpLink({
    // An absolute URL should be used here
    uri: GRAPHQL_URI,
});

const csrfLink = new ApolloLink((operation, forward) => {

    // Use the setContext method to set the X-CSRF-TOKEN header back.
    operation.setContext({
        headers: {
            'X-CSRF-TOKEN': document.querySelector(`meta[name='csrf-token']`).content
        }
    });

    // Call the next link in the middleware chain.
    return forward(operation);
});

// Create the apollo client
const apolloClient = new ApolloClient({
    connectToDevTools: APOLLO_DEV_TOOLS,
    link: csrfLink.concat(httpLink),
    cache: new InMemoryCache(),
    defaultOptions: {
        query: {
            // TODO: completely move to graphql API so that mutations
            // will also update the cache
            fetchPolicy: 'no-cache'
        }
    }
});

export default apolloClient;
